/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';

const  projectsetupdata =  (data) => {

  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.preProject.url,
        maverickPortalApiEndPoint.preProject.methodType,
        data
      )
      .then(response => {       
        const res = response.data;
        resolve({ res });
      });
  });
};


export { projectsetupdata};
